import App from './App.vue'
import router from './router'
import plugins from './plugins'
import axios from './plugins/axios'
import toast from './plugins/toastification'
import emailPasteHandler from './plugins/emailPasteHandler'
import store from "./store";
import { createApp } from 'vue'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "@/assets/css/app.css"
import "@/assets/css/responsive.css"
import "@/assets/css/fonts.css";
import "@/assets/css/fontawesome/css/fontawesome.css";
import "@/assets/css/fontawesome/css/solid.css";
import VueGoogleMaps from "@fawmi/vue-google-maps";

import clickOutside from "./directives/clickOutside";
import ConfirmModal from "@/components/Utilities/ConfirmModal.vue";
import TableEmptyState from "@/components/Utilities/TableEmptyState.vue";

export const app = createApp(App)

app.component('ConfirmModal', ConfirmModal)
app.component('TableEmptyState', TableEmptyState)

app.use(router)
app.use(plugins)
app.use(axios)
app.use(toast)
app.use(emailPasteHandler)
app.use(store);

app.directive("click-outside", clickOutside);

app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: "places",
  },
});

app.mount("#app")
